import { create } from "zustand";

type Updater<T> = T | ((previous: T) => T);

const resolveValue = <T>(value: Updater<T>, previous: T): T =>
  typeof value === "function" ? (value as (previous: T) => T)(previous) : value;

type WorkspaceUiState = {
  expanded: boolean;
  showDialog: boolean;
  newTimeEntrySource: "timeline" | "time-view" | null;
  defaultDate: Date;
  showWelcome: boolean;
  userInactive: boolean;
  matterScrollRequest: {
    matterNumber: string | number;
    requestId: number;
    focusEntryId?: string | number | null;
  } | null;
  setExpanded: (expanded: Updater<boolean>) => void;
  setShowDialog: (showDialog: boolean) => void;
  setNewTimeEntrySource: (source: "timeline" | "time-view" | null) => void;
  setDefaultDate: (defaultDate: Date) => void;
  setShowWelcome: (showWelcome: boolean) => void;
  setUserInactive: (userInactive: boolean) => void;
  requestMatterScroll: (matterNumber: string | number, focusEntryId?: string | number | null) => void;
};

export const useWorkspaceUiStore = create<WorkspaceUiState>((set) => ({
  expanded: false,
  showDialog: false,
  newTimeEntrySource: null,
  defaultDate: new Date(),
  showWelcome: false,
  userInactive: false,
  matterScrollRequest: null,
  setExpanded: (expanded) =>
    set((state) => ({ expanded: resolveValue(expanded, state.expanded) })),
  setShowDialog: (showDialog) => set({ showDialog }),
  setNewTimeEntrySource: (newTimeEntrySource) => set({ newTimeEntrySource }),
  setDefaultDate: (defaultDate) => set({ defaultDate }),
  setShowWelcome: (showWelcome) => set({ showWelcome }),
  setUserInactive: (userInactive) => set({ userInactive }),
  requestMatterScroll: (matterNumber, focusEntryId) =>
    set((state) => ({
      matterScrollRequest: {
        matterNumber,
        requestId: (state.matterScrollRequest?.requestId ?? 0) + 1,
        focusEntryId: focusEntryId ?? null,
      },
    })),
}));
